import { defineRule } from 'vee-validate'

const corporateRegistrationNumber = () => {
  defineRule<string, any[]>(
    'corporate_registration_number',
    (value, _target, _ctx: any) => {
      if (!value) {
        return true
      }
      return testCorporateRegistrationNumber(value)
    },
  )
}

export default corporateRegistrationNumber
